import React, { Component } from 'react'; import RecapContainer from '../../containers/recapContainer';
import PropTypes from 'prop-types';

const propTypes = {
  accessible: PropTypes.bool,
  nextFunc: PropTypes.func
};

class ColorRecap extends Component {
  renderPause() {
    return (
      <div>
        <p>
          Based on your attendee type, you're only eligible to sign up for some of these sessions.
          What visual cues are there to let you know?
        </p>
        <p>
          Check out the screen of the person across from you.
        </p>
        <p>
          On both screens, sessions have a blue or orange dot next to the session name.
          What does {this.props.accessible ? 'your' : 'the other'} screen have
          that {this.props.accessible ? 'the other screen' : 'yours'} doesn't?
        </p>
      </div>
      )
  }

  renderRecap() {
    return (
      <div>
        <p>
          You can use color to <em>help</em> convey status or categorization,
          but always paired it with text or iconography so everyone, including
          colorblind viewers, can understand your content.
        </p>
      </div>
      )
  }

  render() {
    return (
      <RecapContainer
      	title='Color as Meaning'
      	nextLabel='Continue to Step 4'
      	nextFunc={this.props.nextFunc}
        pause={this.renderPause()}
        recap={this.renderRecap()}
      />
    );
  }
}

ColorRecap.propTypes = propTypes;
export default ColorRecap;



// WEBPACK FOOTER //
// ./src/steps/color/recap.js